import { PropTypes } from 'prop-types';
import React, { useState, useEffect } from 'react';
import { MessageSquare } from 'react-feather';
import LinkButton from 'components/shared/LinkButton';
import classNames from 'classnames';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import RevealFeedbackForm from './RevealFeedbackForm';
import ModalFeedbackForm from './ModalFeedbackForm';

export const BetaFeedback = ({
  className,
  multiLineText,
  betaFeatureName,
  feedbackWithFeatureName,
  recipient,
  inline,
}) => {
  const [isRevealed, setIsRevealed] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    if (isRevealed) {
      document
        .getElementsByClassName('ModalTakeover-background Modal-background')[0]
        .scrollTo({ left: 0, top: 10000, behavior: 'smooth' });
    }
  }, [isRevealed]);

  return (
    <div
      className={classNames(className, {
        'd-f jc-c pb-2': !!className?.includes('aa-editor'),
      })}
    >
      {!isHidden && (
        <div className="d-f">
          <LinkButton
            className="Underline-on-hover td-n d-f"
            onClick={
              !inline
                ? () => setShowModal(true)
                : () => setIsRevealed(prev => !prev)
            }
          >
            <MessageSquare size="25" className="pr-4 c-link" />
            {feedbackWithFeatureName ? (
              <Text variant={TEXT_VARIANTS.BODY_LINK} className="td-n">
                {t('beta_feedback.give_us_feedback_on')}
                {multiLineText && <br />}
                {betaFeatureName}
              </Text>
            ) : (
              <Text variant={TEXT_VARIANTS.BODY_LINK} className="td-n">
                <div className="d-f ta-r">
                  {t('beta_feedback.give_us_feedback')}
                </div>
              </Text>
            )}
          </LinkButton>
        </div>
      )}
      {isRevealed ? (
        <RevealFeedbackForm
          recipient={recipient}
          betaFeatureName={betaFeatureName}
          updateHiddenState={state => {
            setIsHidden(state);
          }}
        />
      ) : (
        <ModalFeedbackForm
          recipient={recipient}
          showModal={showModal}
          updateShowModal={state => setShowModal(state)}
          betaFeatureName={betaFeatureName}
        />
      )}
    </div>
  );
};

BetaFeedback.propTypes = {
  className: PropTypes.string,
  betaFeatureName: PropTypes.string,
  feedbackWithFeatureName: PropTypes.bool,
  recipient: PropTypes.string,
};
